var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", [
    _c("label", { staticClass: "file-select" }, [
      _c("div", { staticClass: "select-button" }, [
        _vm.value
          ? _c("span", { attrs: { title: _vm.value.name } }, [
              _vm._v(
                _vm._s(_vm.titleSelected) +
                  _vm._s(_vm.cutDocName(_vm.value.name, 16))
              )
            ])
          : _c("span", { staticClass: "title-select" }, [
              _vm._v(_vm._s(_vm.title))
            ])
      ]),
      _c("input", {
        attrs: { type: "file" },
        on: { change: _vm.handleFileChange }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-742880ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-742880ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/_any/InputFile.vue
// module id = pbzl
// module chunks = 41